import NotFoundSVG from '../../assets/svg/marketing/404';
import Link from 'next/link';
import Text from '@/components/typography/text';



export default function NotFound() {
  return (
    <div className="relative max-w-site min-h-[50vh] mx-auto px-site-padding py-6 flex justify-center items-center gap-10 max-sm:flex-col-reverse max-sm:justify-center">
      <div className="w-[35%] flex flex-col gap-2 items-center max-md:w-1/2 max-sm:w-full max-sm:text-center">
        <Text size="large" className="text-copy-dark center  font-bold">We've hit a plot twist!</Text>
        <Text size="medium" className="text-copy-dark center">This page can't be found.</Text>
        <Text size="medium" className="text-copy-dark center mt-2">Please explore:</Text>
        <div className="flex flex-col items-start gap-2 text-primary font-bold underline leading-[1.5] max-sm:items-center">
          <Link href="/" aria-label="Go to homepage">
            Home
          </Link>
          <Link href="/categories" aria-label="Go to book categories">
            Categories
          </Link>
          <Link
            href="/collections"
            aria-label="Go to curated collections of books"
          >
            Collections
          </Link>
          <Link href="/blog" aria-label="Go to blog">
            Blog
          </Link>
          <Link
            href="https://help.pangobooks.com/en/articles/6222077-how-can-i-contact-pangobooks"
            aria-label="Go to help article on how to contact us"
          >
            Contact us
          </Link>
        </div>
      </div>
      <div className="w-full max-w-[20rem] px-3 flex justify-center max-sm:max-w-[16rem] max-sm:mx-auto max-sm:mb-8">
        <NotFoundSVG />
      </div>
    </div>
  );
}
